import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import CitySelector from "./CitySelector";
import { useTranslation } from "@/hooks/useTranslation";

export default function SecondaryLocationField({
  form,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) {
  const t = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="secondaryLocation"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel className="text-gray-400">
              {t.USER_FORM.LABELS.SECONDARY_LOCATION}
            </FormLabel>
            <div>
              <FormControl>
                <CitySelector
                  formField={field}
                  placeholder={t.USER_FORM.PLACEHOLDERS.CITY_INPUT}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
